<form class="flex flex-column gap-4" [formGroup]="form" (ngSubmit)="onSubmit()">
  <section class="flex flex-column gap-3">
    <h2 class="text-xl font-semibold text-color m-0">Contacto</h2>

    <div class="grid">
      <div class="col-12 md:col-6 flex flex-column gap-1">
        <label class="text-sm font-semibold text-color" for="persona-direccion">Dirección</label>
        <input
          pInputText
          id="persona-direccion"
          formControlName="direccion"
          placeholder="Ej: Av Falsa 5588"
          class="w-full agregar-persona-step__underline"
          autocomplete="street-address"
        />
      </div>

      <div class="col-12 md:col-6 flex flex-column gap-1">
        <label class="text-sm font-semibold text-color" for="persona-ciudad">Localidad</label>
        <input
          pInputText
          id="persona-ciudad"
          formControlName="ciudad"
          placeholder="Ej: Gonzalez Catan"
          class="w-full agregar-persona-step__underline"
          autocomplete="address-level2"
        />
      </div>

      <div class="col-12 md:col-6 flex flex-column gap-1">
        <label class="text-sm font-semibold text-color" for="persona-email">E-Mail</label>
        <input
          pInputText
          id="persona-email"
          type="email"
          formControlName="email"
          placeholder="Ej: carlosnavarro@hotmail.com"
          class="w-full agregar-persona-step__underline"
          autocomplete="email"
        />
      </div>
    </div>
  </section>

  <section class="flex flex-column gap-3">
    <h2 class="text-xl font-semibold text-color m-0">Información adicional</h2>

    <div class="grid">
      @if (mostrarAsignarLider()) {
        <div class="col-12 md:col-6 flex flex-column gap-1">
          <label class="text-sm font-semibold text-color" for="persona-id-lider">
            {{ esContadorPuro() ? 'Líder' : 'Asignar líder' }}
          </label>
          @if (loading()) {
            <p-skeleton height="2.5rem" borderRadius="6px" />
          } @else {
            <p-select
              inputId="persona-id-lider"
              formControlName="idLider"
              [options]="liderOptions()"
              optionLabel="label"
              optionValue="value"
              placeholder="Ninguno"
              styleClass="w-full agregar-persona-step__underline-select"
              [disabled]="saving()"
            />
          }
        </div>
      }

      <div class="col-12 md:col-6 flex flex-column gap-1">
        <label class="text-sm font-semibold text-color" for="persona-ministerio">Ministerio</label>
        @if (loading()) {
          <p-skeleton height="2.5rem" borderRadius="6px" />
        } @else {
          <p-select
            inputId="persona-ministerio"
            formControlName="ministerio"
            [options]="ministerioOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Ninguno"
            styleClass="w-full agregar-persona-step__underline-select"
            [disabled]="saving()"
          />
        }
      </div>

      @if (mostrarNivelPersonal()) {
        <div class="col-12 md:col-6 flex flex-column gap-1">
          <label class="text-sm font-semibold text-color" for="persona-nivel">Nivel personal</label>
          <p-select
            inputId="persona-nivel"
            formControlName="nivelPersonal"
            [options]="nivelOptions"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full agregar-persona-step__underline-select"
          />
        </div>
      }
    </div>
  </section>

  @if (mostrarPrivilegios()) {
    <section class="flex flex-column gap-3">
      <h2 class="text-xl font-semibold text-color m-0 text-center">Privilegios</h2>

      <div class="flex flex-column md:flex-row justify-content-center gap-3 md:gap-5">
        <div class="flex align-items-center gap-2">
          <p-checkbox formControlName="admin" [binary]="true" inputId="persona-priv-admin" />
          <label class="text-sm text-color m-0" for="persona-priv-admin">Administrador</label>
        </div>
        <div class="flex align-items-center gap-2">
          <p-checkbox formControlName="lider" [binary]="true" inputId="persona-priv-lider" />
          <label class="text-sm text-color m-0" for="persona-priv-lider">Líder</label>
        </div>
        <div class="flex align-items-center gap-2">
          <p-checkbox formControlName="contador" [binary]="true" inputId="persona-priv-contador" />
          <label class="text-sm text-color m-0" for="persona-priv-contador">Contador</label>
        </div>
      </div>

      @if (mostrarMailPreview()) {
        <p class="m-0 text-center text-color" data-testid="mail-access-preview">
          {{ mailAccessPreview() }}
        </p>
      }
    </section>
  }

  <div class="flex flex-column-reverse md:flex-row justify-content-between gap-3 pt-3">
    <p-button
      type="button"
      label="Anterior"
      icon="pi pi-arrow-left"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full md:w-auto"
      (onClick)="back.emit()"
    />
    <p-button
      type="submit"
      label="Finalizar"
      icon="pi pi-check"
      styleClass="w-full md:w-auto uppercase"
      [disabled]="loading() || saving()"
    />
  </div>
</form>